import { useEffect } from 'react';
import { useLocation, Link, Navigate } from 'react-router-dom';
import { CheckCircle2, Home, FolderOpen } from 'lucide-react';
import SEO from '@/components/SEO';

const Confirmation = () => {
  const location = useLocation();
  const form = location.state?.form as { firstName?: string; lastName?: string; email?: string; phone?: string; company?: string; subject?: string } | undefined;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!form) return <Navigate to="/contact" replace />;

  return (
    <>
      <SEO title="Confirmation — Cygnature Production" description="Votre message a bien été envoyé." noindex />
      <section className="px-6 lg:px-8 py-20 md:py-28 bg-petrol text-petrol-foreground">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-6">
            <CheckCircle2 size={40} className="text-primary" />
          </div>
          <h1 className="font-heading text-3xl md:text-5xl font-bold">
            Merci {form.firstName} !
          </h1>
          <p className="mt-5 text-petrol-foreground/60 max-w-lg mx-auto text-sm md:text-base leading-relaxed">
            Votre message a bien été envoyé. Nous reviendrons vers vous rapidement.
          </p>
        </div>
      </section>

      <section className="px-6 lg:px-8 py-16 md:py-20 bg-background">
        <div className="max-w-3xl mx-auto">
          <div className="rounded-xl border border-border bg-card p-6 md:p-8 mb-8">
            <h2 className="font-heading text-base font-bold text-foreground mb-4">Récapitulatif</h2>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 text-sm">
              <div><dt className="text-muted-foreground text-xs">Nom</dt><dd className="text-foreground font-medium">{form.firstName} {form.lastName}</dd></div>
              {form.company && <div><dt className="text-muted-foreground text-xs">Société</dt><dd className="text-foreground font-medium">{form.company}</dd></div>}
              {form.email && <div><dt className="text-muted-foreground text-xs">Email</dt><dd className="text-foreground font-medium">{form.email}</dd></div>}
              {form.phone && <div><dt className="text-muted-foreground text-xs">Téléphone</dt><dd className="text-foreground font-medium">{form.phone}</dd></div>}
            </dl>
          </div>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-border text-foreground font-heading text-sm font-medium hover:bg-muted transition-colors"><Home size={16} /> Retour à l'accueil</Link>
            <Link to="/services" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary text-primary-foreground font-heading text-sm font-medium hover:bg-primary/90 transition-colors"><FolderOpen size={16} /> Voir nos services</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Confirmation;
